import { groupEntityName } from '../../../../backend/features/groups/shared';
import { getGroupFilter } from '../../../../backend/features/permissions/shared';
import { useUserState } from '../../../../ui/hooks';
import { useStorageList } from '@juvare/platform-sdk-react/ui/hooks';
export function useGroupList(request, filterBased) {
    const userState = useUserState();
    const response = useStorageList(groupEntityName, mapGroupRequest(userState, request, filterBased));
    return Object.assign(Object.assign({}, response), { data: response.data
            ? {
                rows: response.data.rows,
                filteredRowCount: response.data.total,
            }
            : undefined, reload: response.mutate });
}
export function mapGroupFilter(userState, filterData, filterBased, selectedGroupId) {
    const filter = getGroupFilter(userState, selectedGroupId);
    if (filterData.search) {
        filter.push({ column: 'search', op: 'full-text-query', value: filterData.search });
    }
    if (filterBased != null) {
        filter.push({ column: 'filterBased', op: '=', value: filterBased });
    }
    return filter;
}
function mapGroupRequest(userState, { filterData, sortColumnKey, sortColumnDesc, offset, limit }, filterBased) {
    const filter = getGroupFilter(userState);
    filter.push(...mapGroupFilter(userState, filterData, filterBased));
    return {
        filter: filter,
        orderBy: [{ column: sortColumnKey, desc: sortColumnDesc }],
        offset,
        limit,
    };
}
